'use client';

import Env from 'src/environmentVariables/EnvironmentVariables';

const useIsMainnet = () => {
	const isMainnet = Env.sdkEnv === 'mainnet-beta';

	return isMainnet;
};

export default useIsMainnet;
